module.exports = __webpack_public_path__ + "img/warning.11834ad1.svg";